<ng-container *transloco="let t; read: 'providers.feedFiles'">
  <div [class]="bare() ? '' : 'rounded-card bg-card p-6 shadow-hairline'">
    @if (!bare()) {
      <div class="mb-1 font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('title') }}</div>
    }
    <p class="m-0 mb-4 text-[12px] leading-[18px] text-ink-3">{{ t('subtitle') }}</p>

    <app-feed-file-list [feedId]="feedId()" [filesCapability]="filesCapability()" [providerType]="providerType()" (changed)="onFilesChanged()" />

    <!-- Delivered sets (read-only) -->
    <div class="mt-6 flex items-center justify-between gap-3 border-t border-hairline pt-5">
      <span class="text-[11px] font-bold uppercase tracking-wide text-ink-3">{{ t('sets.title') }}</span>
      <button type="button" (click)="refresh()" class="text-[13px] font-semibold text-link hover:underline">
        {{ t('refresh') }}
      </button>
    </div>
    <p class="m-0 mt-1 text-[12px] leading-[18px] text-ink-3">{{ t('sets.subtitle') }}</p>

    <div class="mt-4 flex flex-col gap-4">
      @if (isLoading()) {
        <span class="text-[13px] text-ink-3">—</span>
      } @else {
        @for (set of fileSets(); track set.id) {
          <div class="rounded-control p-4 shadow-hairline">
            <div class="flex flex-wrap items-center gap-x-3 gap-y-1.5">
              <app-label-badge [dot]="statusDot(set.status)">{{ t('status.' + set.status) }}</app-label-badge>
              <span class="text-[12px] text-ink-3" [attr.title]="set.createdAt">
                {{ set.createdAt | date: 'medium' }} · {{ relativeTime(set.createdAt) }}
              </span>
            </div>

            @if (set.statusMessage) {
              <p class="m-0 mt-2 text-[12px]" [class.text-danger]="set.status === 'FAILED'" [class.text-ink-2]="set.status !== 'FAILED'">
                {{ set.statusMessage }}
              </p>
            }

            <table class="mt-3 w-full border-collapse text-left text-[12px]">
              <thead>
                <tr class="text-[11px] uppercase tracking-wide text-ink-3">
                  <th class="py-1.5 pr-3 font-semibold">{{ t('columns.file') }}</th>
                  <th class="py-1.5 pr-3 font-semibold">{{ t('columns.role') }}</th>
                  <th class="py-1.5 pr-3 font-semibold">{{ t('columns.size') }}</th>
                  <th class="py-1.5 pr-3 font-semibold">{{ t('columns.sha256') }}</th>
                  <th class="py-1.5"></th>
                </tr>
              </thead>
              <tbody>
                @for (entry of set.files; track entry.id) {
                  <tr class="border-t border-hairline align-top">
                    <td class="max-w-[220px] py-1.5 pr-3">
                      <div class="truncate text-ink-1" [attr.title]="entry.filename">{{ entry.filename }}</div>
                      @if (metadataEntries(entry).length) {
                        <div class="mt-1 flex flex-wrap gap-1">
                          @for (m of metadataEntries(entry); track m[0]) {
                            <span class="rounded-control border border-hairline bg-sunken px-1.5 py-0.5 font-num text-[11px] text-ink-2">{{ m[0] }}: {{ m[1] }}</span>
                          }
                        </div>
                      }
                    </td>
                    <td class="py-1.5 pr-3 text-ink-2">{{ entry.role || '—' }}</td>
                    <td class="py-1.5 pr-3 font-num text-ink-2">{{ formatBytes(entry.size) }}</td>
                    <td class="py-1.5 pr-3 font-num text-ink-3" [attr.title]="entry.sha256">{{ entry.sha256.slice(0, 12) }}…</td>
                    <td class="py-1.5 text-right">
                      <button
                        type="button"
                        (click)="download(set, entry)"
                        [disabled]="downloadingId() === entry.id"
                        class="font-semibold text-link disabled:opacity-40 hover:underline"
                      >
                        {{ t('download') }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @empty {
          <span class="text-[13px] text-ink-3">{{ t('sets.empty') }}</span>
        }
      }
    </div>
  </div>
</ng-container>
